export interface ProgressBarProps {
  /** 0-100 */
  value: number;
  tone?: "primary" | "success" | "warning" | "danger";
  label?: string;
}

const TONE_COLOR: Record<NonNullable<ProgressBarProps["tone"]>, string> = {
  primary: "var(--color-primary)",
  success: "var(--color-success)",
  warning: "var(--color-warning)",
  danger: "var(--color-danger)",
};

/** Velocity/progress affordance — used on deal stages, quota attainment, etc. */
export function ProgressBar({ value, tone = "primary", label }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div>
      {label && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "var(--font-size-xs)",
            color: "var(--color-text-muted)",
            marginBottom: "var(--space-1)",
          }}
        >
          <span>{label}</span>
          <span>{pct}%</span>
        </div>
      )}
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        style={{
          height: 8,
          borderRadius: "var(--radius-pill)",
          background: "var(--color-border)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            borderRadius: "var(--radius-pill)",
            background: TONE_COLOR[tone],
            transition: "width var(--duration-standard) var(--ease-standard)",
          }}
        />
      </div>
    </div>
  );
}
